import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_APPOINTMENT_BY_ID } from "../../action-types/actions";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

export const getAppointmentById = createAsyncThunk(
  ACTIONS_GET_APPOINTMENT_BY_ID.get_appointment_by_id,
  async (appointmentId, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getAppointmentById}/${appointmentId}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
